import {
  FC,
  createContext,
  PropsWithChildren,
  useContext,
  useMemo
} from 'react'

import usePopup, { PopupReturnType } from 'hooks/usePopup'
import { initialPopup } from '../../../hooks/constants'

type ContextProps = {
  expectedSavingsByCategoryPopup: PopupReturnType
  filtersPopup: PopupReturnType
}

const basePopup = (title: string) => ({
  title
})

const DashboardPopupContext = createContext<ContextProps>({
  expectedSavingsByCategoryPopup: initialPopup,
  filtersPopup: initialPopup
})

const DashboardPopupProvider: FC<PropsWithChildren> = ({ children }) => {
  const expectedSavingsByCategoryPopupProps = usePopup(
    basePopup('Expected savings by category')
  )

  const filtersPopupProps = usePopup(basePopup('Filters'))

  const context = useMemo(
    () => ({
      expectedSavingsByCategoryPopup: expectedSavingsByCategoryPopupProps,
      filtersPopup: filtersPopupProps
    }),
    [expectedSavingsByCategoryPopupProps, filtersPopupProps]
  )

  return (
    <DashboardPopupContext.Provider value={context}>
      {children}
    </DashboardPopupContext.Provider>
  )
}

export const useDashboardPopup = () => useContext(DashboardPopupContext)

export default DashboardPopupProvider
